import { useEffect } from 'react';

import type { ProductKeys } from '../../../../constants/product-keys';

type ResetProductsWithTimeoutProps = {
	setProductsWithTimeout: React.Dispatch<React.SetStateAction<ProductKeys[] | undefined>>;
};

export const ResetProductsWithTimeout = ({
	setProductsWithTimeout,
}: ResetProductsWithTimeoutProps) => {
	useEffect(() => {
		setProductsWithTimeout(undefined);
	}, [setProductsWithTimeout]);

	return null;
};
